import React, { Component } from "react";

import "./PharseSection.scss"
class PharseSection extends Component {
    render() {
        return (
            <div className="pharse-section">
                <div className="pharse-container">
                    <div className="image"></div>
                    <div className="pharse">
                        השורה המעוררת השראה הזאת מייצגת ומסמלת את האירוויזיון. זה על הכללה. זה על גיוון. זה על אחדות.
                </div>
                    <div className="credit">יאן אולה סאנד - מפקח האירוויזיון</div>
                </div>
            </div>
        );
    }
}

export default PharseSection;



// WEBPACK FOOTER //
// ./src/Components/PhraseSection/PharseSection.js